export default __webpack_public_path__ + "static/Rachel-68640ecb88a1891a3f57080e6ddd8c53.png";